<template>
  <b-row>
    <b-col>
      <LineItemThumbnails :preview_urls="line.preview_urls" popover />
    </b-col>
    <b-col>
      <div><b>Qty:</b> {{ +line.quantity * +line.boxSize}}</div>
      <div><b>Total:</b> ${{ line.price_incl_tax.toFixed(2)}}</div>
    </b-col>
    <b-col>
      <b-button
        variant="clear"
        class="d-lg-block" v-if="canEditDesign" @click="editDesign">Edit Design</b-button>
      <b-button
        variant="clear"
        class="d-lg-block" v-if="canChange" @click="changeProduct">Change</b-button>
      <b-button
        variant="clear"
        class="d-lg-block" v-if="canDelete" @click="deleteLine">Delete</b-button>
    </b-col>
    <b-col sm="12">
      <div v-if="!changing">
        {{line.product ? line.product.title : '(product information is loading)'}}
      </div>
      <LineDetailProductForm v-else :line="line" @done="changing = false"/>
    </b-col>
  </b-row>
</template>

<style lang="scss" scoped>
.order-header {
  margin-bottom: 1em;
}
.order-line {
  border-top: 1px solid gray;
  padding: 0.5em 0;
}

.btn-clear {
  // Compress slightly so three buttons fit without pushing the next row down
  height: 30px;
}
</style>

<script>
import LineDetailProductForm from "./LineDetailProductForm";
import {mapGetters, mapActions} from 'vuex';
export default {
  components: {LineDetailProductForm},
  props: {
    line: Object,
    order: Object,
    canDelete: Boolean,
    canChange: Boolean
  },
  data() {
    return {
      changing: false
    }
  },
  computed: {
    ...mapGetters(['flags']),
    canEditDesign() {
      return this.flags.approvalEditDesign;
    }
  },
  methods: {
    ...mapActions(['deleteOrderLine']),
    changeProduct() {
      // Show the full product editing machinery
      this.changing = true;
    },
    deleteLine() {
      return this.deleteOrderLine({line: this.line.id});
    },
    editDesign() {
      let unlock = this.flags.approvalEditDesignUnlocks ? 'yes' : undefined;
      this.$router.push({
        name: 'Editor',
        params: {
          id: this.line.designId,
          from: 'orders/'+this.order.id
        },
        query: {
          fill: 'no',
          unlock
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/dashboard/orders/LineDetailRow.vue